import { useBooleanFlag } from '@trm/feature-flags/web';

export const useEnableTraderProfileAdminFlag = () => ({
  isTraderProfileAdminEnabled: useBooleanFlag('enable-trader-profile-admin', false),
});
